import moment from 'moment';

// src/redux/reducers/addressDetail.jsでしか使われてない
export const Tab = {
  ALL: 0,
  SILENT: 5,
  REACTED: 6,
  CONVERTED: 7,
  WARNING: 18,
  ERROR: 19,
};

export const AddressBookTab = {
  ALL: 0,
  WARNING: 18,
  ERROR: 19,
};

export const BottomMenuValue = {
  APPROACH: 0,
  EDIT: 1,
  DELETE: 2,
};

export const DialogType = {
  CREATE: 0,
  EDIT: 1,
  ERROR: 2,
  WARNING: 3,
  WARNING_DETAIL: 4,
};

export const SentDateRangeDialogType = {
  SENT_ONLY: 'sent_only',
  SENT_EXCEPT: 'sent_except',
};

export const CorporationSentDateRangeDialogType = {
  CORPORATION_SENT_ONLY: 'corporation_sent_only',
  CORPORATION_SENT_EXCEPT: 'corporation_sent_except',
};
export const FollowCallOrderDateRangeDialogType = {
  FOLLOW_CALL_ORDER_ONLY: 'follow_call_order_only',
  FOLLOW_CALL_ORDER_EXCEPT: 'follow_call_order_except',
};

export const CrmType = {
  SALESFORCE: 1,
  MARKETO: 2,
  SANSAN: 3,
  HUBSPOT: 4,
};

export const PaymentType = {
  CARD: 1,
  INVOICE: 2,
};

export const countries = {
  JAPAN: {
    name: "日本",
    ISO: 392,
  },
};

export const TagValidStatus = {
  NO_TRACKING: 0,
  OK: 1,
  NG: 2,
};

export const NotificationType = {
  EXE_FILTER_NEW_EXE: 0,
  SYSTEM_NOTIF: 1,
  RECOMMEND_RELOCATION_PERSONNEL: 2,
  PENDING_APPOINTMENT_SCHEDULE: 3,
};

export const HouseListDirectory = {
  MAIN: { name: "メインボックス", path: "/house-list/main" },
  WARNING: { name: "警告ボックス", path: "/house-list/warning" },
  ERROR: { name: "エラーボックス", path: "/house-list/error" },
  NG_LIST: { name: "送付NGリスト", path: "/house-list/ng" },
};

export const OwnerType = {
  OWN: { value: "1", name: "自分" },
  ALL: { value: "0", name: "チーム" },
};

export const AccountSettingDirectory = {
  GENERAL: { text: "基本", value: 0, path: "/setting/general" },
  PLANS: { text: "プラン", value: 1, path: "/setting/plans" },
  BILLING: { text: "支払い", value: 2, path: "/setting/billing" },
  INTEGRATIONS: { text: "連携", value: 3, path: "/setting/integrations" },
};

export const ChildAccountSettingDirectory = {
  ACCOUNT_LIST: { name: "アカウント一覧", path: "/setting/child-accounts" },
  AUTHORITY: { name: "権限一覧", path: "/setting/child-accounts/authority" },
  OWNER: { name: "オーナーアカウント設定", path: "/setting/child-accounts/owner" },
};

export const SalesforceSettingDirectory = {
  ADDRESS_BOOK: {
    text: "自社リスト",
    value: 0,
    setting_path: "/setting/integrations/salesforce/address-setting",
    setup_path: "/setting/integrations/salesforce/address-setup",
    setting_edit_path: "/setting/integrations/salesforce/address-edit",
    complete_desc: "SalesforceリストがKeyman Letterの自社リストに同期されるようになりました。「同期」ボタンをクリックすると、Salesforceリストが自社リストに同期されます。Salesforceのレコードにレターを送付したり、タイムラインでステータス管理できます。",
    setting_desc: "Salesforce・Keyman Letter間で同期を自動化するための項目マッピングを設定します。マッピングした項目はSalesforce・Keyman Letter間で手動で同期されます。同期を開始するには、「アカウント ＞ 連携 ＞ Salesforce」と「自社リスト ＞ サイドバー」にある同期ボタンをクリックしてください。",
    mapping_setup_desc: "SalesforceからKeyman Letterへの同期を自動化するための項目マッピングを設定します。下記Keyman Letter項目に該当するSalesforce項目を追加(複数可※1)してください。この設定は「アカウント管理 > 連携」よりいつでも変更できます。",
    preview_setup_desc: "問題ない場合は「設定を保存」ボタンをクリックして設定を完了させてください。自社リストのインポート設定は、「アカウント管理 > 連携 > Salesforce」よりいつでも変更できます。",
    mapping_cation_desc: "※1 サービス間でデータ構造が異なる場合があるため、1つのKeyman Letter項目に対し、複数のSalesforce項目を結合してマッピングすることができます。たとえば、Keyman Letterでは住所が一つの項目にまとまっていますが、Salesforceでは複数の項目に分かれているかもしれません。",
  },
  EXE_LIST: {
    text: "キーマンデータベース",
    value: 1,
    setting_path: "/setting/integrations/salesforce/exe-setting",
    setup_path: "/setting/integrations/salesforce/exe-setup",
    setting_edit_path: "/setting/integrations/salesforce/exe-edit",
    complete_desc: "キーマンデータベースがSalesforceに同期されるようになりました。マッピングした項目は、キーマンデータベースからレターを注文した際に、自動的にSalesforce内でキャンペーンが作成され、Keyman LetterからSalesforceに同期されます。また、これまで注文済みキーマンをSalesforceに同期したい場合、「注文履歴」画面より設定できます。",
    setting_desc: "Salesforce・Keyman Letter間で同期を自動化するための項目マッピングを設定します。マッピングが定義された状態で、「注文履歴」画面で「Salesforceに同期」を選択すると、キーマンデータベースからのレター注文はKeyman LetterからSalesforceのキャンペーンに、注文済みキーマンはSalesforceの指定オブジェクトに、同期されます。",
    mapping_setup_desc: "キーマンデータベースをSalesforceに同期する際の項目マッピングを設定します。下記Keyman Letterキーマンデータベース項目に該当するSalesforce項目を設定してください。この設定は「アカウント管理 > 連携 > Salesforce」よりいつでも変更できます。",
    preview_setup_desc: "問題ない場合は「設定を保存」ボタンをクリックして設定を完了させてください。キーマンデータベースのエクスポート設定は、「アカウント管理 > 連携 > Salesforce」よりいつでも変更できます。",
    mapping_cation_desc: "※1 キーマンデータベースを連携する場合、セールスフォース上の取引先の有無に関わらず、キーマンの所属取引先が、新規取引先として追加されますので、ご注意ください。",
    required_fields:
    {
      lead: [
        {
          sobject_name: "Lead",
          field: "LastName",
          text: "リード・姓は必須です",
        },
      ],
      account_contact: [
        {
          sobject_name: "Account",
          field: "Name",
          text: "取引先・取引先名は必須です",
        },
        {
          sobject_name: "Contact",
          field: "LastName",
          text: "取引先責任者・姓は必須です",
        },
      ]
    }
  },
  TIMELINE_STATUS: {
    text: "タイムライン",
    value: 2,
    setting_path: "/setting/integrations/salesforce/timeline-status-setting",
    setting_edit_path: "/setting/integrations/salesforce/timeline-status-setting-edit",
    setup_path: "/setting/integrations/salesforce/timeline-status-setup",
    complete_desc: "タイムラインがSalesforceに同期されるようになりました。マッピングした項目は、レターの発送状況が変更された際、もしくはオペレーターがコールした際に、自動的にSalesforce内で活動(Event)が作成され、Keyman LetterからSalesforceに同期されます。また、これまで注文済みキーマンをSalesforceに同期したい場合、「注文履歴」画面より設定できます。",
    setting_desc: "Salesforce・Keyman Letter間で同期を自動化するための項目マッピングを設定します。マッピングが定義された状態で、「注文履歴」画面で「Salesforceに同期」を選択すると、レターの注文はKeyman LetterからSalesforceのキャンペーンに、発送ステータスはSalesforceの活動(Event)に、同期されます。フォローコールの注文はKeyman LetterからSalesforceのキャンペーンに、コール履歴はSalesforceの活動(Event)に、同期されます。",
    mapping_setup_desc: "キーマンデータベースをSalesforceに同期する際の項目マッピングを設定します。下記Keyman Letterタイムライン項目に該当するSalesforce項目を設定してください。この設定は「アカウント管理 > 連携 > Salesforce」よりいつでも変更できます。",
    preview_setup_desc: "問題ない場合は「設定を保存」ボタンをクリックして設定を完了させてください。タイムラインのエクスポート設定は、「アカウント管理 > 連携 > Salesforce」よりいつでも変更できます。",
    mapping_cation_desc: "※1 活動(Event)のビュー設定によっては、表示されない項目もございますので、ご注意ください。",
    required_fields:
    {
      event: [
        {
          sobject_name: "Event",
          field: "Subject",
          text: "タイトルは必須です",
        },
        {
          sobject_name: "Event",
          field: "ActivityDateTime",
          text: "発送日時・通話日時は必須です",
        },
        {
          sobject_name: "Event",
          field: "Description",
          text: "説明(発送ステータスや通話結果・通話内容)は必須です",
        },
      ]
    }
  },
};

export const AddressType = {
  USER_UPLOAD: { value: 0, text: "" },
  SALESFORCE: { value: 1, text: "Salesforceレコード" },
};

export const WarningAddressType = {
  DUPLICATE: { value: 0, text: "すでに同じアドレスが登録されています" },
  CONTAINS_SYMBOL: { value: 1, text: "記号が含まれています" },
  ADDRESS_LENGTH: { value: 2, text: "脱字の可能性を検出しました" },
  INVALID_POSTCODE: { value: 3, text: "存在しない郵便番号です" },
  INVALID_ADDRESS_REPEATING_PATTERNS: {
    value: 4,
    text: "住所に誤字の可能性を検出しました",
  },
  INVALID_ADDRESS_NOT_MATCHING_POSTCODE_DATA: {
    value: 5,
    text: "指定の住所は指定の郵便番号ではありません",
  },
  DUPLICATE_EXECUTIVE_PERSON: {
    value: 6,
    text: "キーマンデータベースと同じアドレスが登録されています。",
  },
};

export const ErrorAddressType = {
  VALIDATION_ERROR: { value: 0, text: "入力内容に不備があります" },
  NG_SENDING_ERROR: { value: 1, text: "送付NGのターゲットです" },
};

export const LinkCorporationStatusType = {
  NOT_LINK: 0,
  LINKING: 1,
  LINK_SUCCESS: 2,
  LINK_FAILURE: 3,
};

export const TagType = {
  CUSTOM_TAG: 0,
  IMPORT_HISTORY: 1,
  TARGET_LIST: 2,
};

export const addressItemFormProps = [
  { key: "post_code", value: "郵便番号", placeholder: "123-4567" },
  { key: "company", value: "会社名", placeholder: "Example Inc." },
  { key: "corporate_number", value: "法人番号", placeholder: "1234567890123" },
  { key: "branch", value: "支店・部署", placeholder: "Sales Division" },
  { key: "position", value: "役職", placeholder: "General Manager" },
  { key: "name", value: "名前", placeholder: "John Doe" },
  { key: "honorific", value: "敬称", placeholder: "Mr." },
  { key: "address", value: "住所", placeholder: "11 W 53rd St, New York, NY" },
  { key: "tel", value: "電話番号", placeholder: "123-456-7890" },
  { key: "fax", value: "FAX番号", placeholder: "123-456-7890" },
  { key: "email", value: "メールアドレス", placeholder: "john.doe@email.com" },
  { key: "tags", value: "リスト", placeholder: "tags" },
];

export const SortType = {
  SORT_TYPE_TAG_NAME_DESC: 1,
  SORT_TYPE_TAG_NAME_ASC: 2,
};

export const TimelineStatusSortType = {
  SORT_TYPE_CREATED_AT_DESC: 1,
  SORT_TYPE_CREATED_AT_ASC: 2,
};

export const DashboardStatusSortType = {
  // 画面には更新日（stated_at）しか表示していない。バックエンドは1と2があるがcreated_atは画面に表示していないため
  // 3と4のみ使用
  SORT_TYPE_STATED_AT_DESC: { value: 3, text: "更新日が新しい順" },
  SORT_TYPE_STATED_AT_ASC: { value: 4, text: "更新日が古い順" },
};

export const HouseListSortType = {
  SORT_TYPE_CREATED_AT_DESC: { value: 5, text: "登録日が新しい順" },
  SORT_TYPE_CREATED_AT_ASC: { value: 6, text: "登録日が古い順" },
  SORT_TYPE_ADDRESS_LEN_DESC: { value: 7, text: "住所の文字数が長い順" },
  SORT_TYPE_ADDRESS_LEN_ASC: { value: 8, text: "住所の文字数が短い順" },
};

export const ErrorAddressSortType = {
  SORT_TYPE_CREATED_AT_DESC: { value: 5, text: "登録日が新しい順" },
  SORT_TYPE_CREATED_AT_ASC: { value: 6, text: "登録日が古い順" },
};

export const WarningAddressSortType = {
  SORT_TYPE_CREATED_AT_DESC: { value: 5, text: "登録日が新しい順" },
  SORT_TYPE_CREATED_AT_ASC: { value: 6, text: "登録日が古い順" },
  SORT_TYPE_ADDRESS_LEN_DESC: { value: 7, text: "住所の文字数が長い順" },
  SORT_TYPE_ADDRESS_LEN_ASC: { value: 8, text: "住所の文字数が短い順" },
};

export const ExecSortType = {
  SORT_TYPE_RELOCATION_AT_DESC: { value: 11, text: "異動日が新しい順" },
  SORT_TYPE_RELOCATION_AT_ASC: { value: 12, text: "異動日が古い順" },
  SORT_TYPE_COMPANY: { value: 9, text: "会社名順" },
  SORT_TYPE_AMOUNT_OF_SALES_DESC: { value: 6, text: "売上高順" },
  SORT_TYPE_NUMBER_OF_EMPLOYEES_DESC: { value: 8, text: "従業員数順" },
  SORT_TYPE_INCLUDE_CONSOLIDATED_NUMBER_OF_EMPLOYEES_DESC: { value: 15, text: "従業員数（連結）順" },
  SORT_TYPE_RECOMMEND_DESC: { value: 13, text: "おすすめ順" },
  SORT_TYPE_HOT_SCORE_ASC: { value: 16, text: "ホット順" },
};

export const DifferenceType = {
  COMPANY_NAME: 1,
  ADDRESS: 2,
  CLOSE: 3,
};

export const TimelineIconType = {
  SYS_STATUS: 0,
  USER_STATUS: 1,
  FOLLOW_CALL_USER_STATUS: 2,
  RESEARCHER_USER_STATUS: 3,
};

// ステータスを追加する場合は検索、ダッシュボード、タイムラインの表示も修正する
export const TimelineLabelType = {
  APPROACH: { value: 0, text: "注文受付", path: "/approach", color: "#1A40FF", backgroundColor: "#F2F4FF" },
  QR_CODE_REACTION: { value: 5, text: "QRコードリアクション", path: "/qr_code_reaction", color: "#805EF5", backgroundColor: "#F7F3FF" },
  APPOINTMENT: { value: 1, text: "商談獲得", path: "/appointment", color: "#3D8D5F", backgroundColor: "#F2FFF8" },
  CLOSE: { value: 2, text: "クローズ", path: "/close", color: "#777777", backgroundColor: "#F2F2F2" },
  APPROACH_NG: { value: 3, text: "アプローチNG", path: "/approach_ng", color: "#FD5F6B", backgroundColor: "#FFF2F2" },
  PROOFREAD_CREATED: { value: 10, text: "校了データ作成完了", path: "/approach", color: "#1A40FF", backgroundColor: "#F2F4FF" },
  ORDER_SHIPPED: { value: 11, text: "発送済み", path: "/approach", color: "#1A40FF", backgroundColor: "#F2F4FF" },
  ORDER_PRINTING: { value: 12, text: "印刷中", path: "/approach", color: "#1A40FF", backgroundColor: "#F2F4FF" },
  RESERVE: { value: 9, text: "注文予約中", path: "/approach", color: "#1A40FF", backgroundColor: "#F2F4FF" },
  NON_CONNECT: { value: 13, text: "未コネクト", path: "/non_connect", color: "#3078F7", backgroundColor: "#F2F6FF" },
  DECLINED: { value: 16, text: "お断り済み", path: "/declined", color: "#1AA7FF", backgroundColor: "#F2FAFF" },
  CONNECT: { value: 14, text: "コネクト", path: "/connect", color: "#22D1DD", backgroundColor: "#F2FEFF" },
  SENT_DOCUMENT: { value: 15, text: "資料送付", path: "/sent_document", color: "#22D179", backgroundColor: "#F2FFF9" },
};

export const DashboardTimelineType = {
  QR_CODE_REACTION: { value: 0, text: TimelineLabelType.QR_CODE_REACTION.text, path: TimelineLabelType.QR_CODE_REACTION.path, color: TimelineLabelType.QR_CODE_REACTION.color, backgroundColor: TimelineLabelType.QR_CODE_REACTION.backgroundColor },
  LEAD_NOTE: { value: 1, text: "リード情報獲得", path: "/lead_note", color: "#1A40FF", backgroundColor: "#F2F4FF" },
  BY_FOLLOW_CALL_STATUS: { value: 2, text: "ステータス別キーマン一覧", path: "/by_follow_call_status" },
  APPROACH: {
    value: 3, text: "アプローチ開始", path: TimelineLabelType.APPROACH.path, color: TimelineLabelType.APPROACH.color, backgroundColor: TimelineLabelType.APPROACH.backgroundColor, combination: [
      TimelineLabelType.APPROACH.value,
      TimelineLabelType.PROOFREAD_CREATED.value,
      TimelineLabelType.ORDER_SHIPPED.value,
      TimelineLabelType.ORDER_PRINTING.value,
    ]
  },
  APPOINTMENT: { value: 4, text: TimelineLabelType.APPOINTMENT.text, path: TimelineLabelType.APPOINTMENT.path, color: TimelineLabelType.APPOINTMENT.color, backgroundColor: TimelineLabelType.APPOINTMENT.backgroundColor, combination: [TimelineLabelType.APPOINTMENT.value] },
  CLOSE: { value: 5, text: TimelineLabelType.CLOSE.text, path: TimelineLabelType.CLOSE.path, color: TimelineLabelType.CLOSE.color, backgroundColor: TimelineLabelType.CLOSE.backgroundColor, combination: [TimelineLabelType.CLOSE.value] },
  APPROACH_NG: { value: 6, text: TimelineLabelType.APPROACH_NG.text, path: TimelineLabelType.APPROACH_NG.path, color: TimelineLabelType.APPROACH_NG.color, backgroundColor: TimelineLabelType.APPROACH_NG.backgroundColor, combination: [TimelineLabelType.APPROACH_NG.value] },
  NON_CONNECT: { value: 7, text: TimelineLabelType.NON_CONNECT.text, path: TimelineLabelType.NON_CONNECT.path, color: TimelineLabelType.NON_CONNECT.color, backgroundColor: TimelineLabelType.NON_CONNECT.backgroundColor, combination: [TimelineLabelType.NON_CONNECT.value] },
  DECLINED: { value: 8, text: TimelineLabelType.DECLINED.text, path: TimelineLabelType.DECLINED.path, color: TimelineLabelType.DECLINED.color, backgroundColor: TimelineLabelType.DECLINED.backgroundColor, combination: [TimelineLabelType.DECLINED.value] },
  CONNECT: { value: 9, text: TimelineLabelType.CONNECT.text, path: TimelineLabelType.CONNECT.path, color: TimelineLabelType.CONNECT.color, backgroundColor: TimelineLabelType.CONNECT.backgroundColor, combination: [TimelineLabelType.CONNECT.value] },
  SENT_DOCUMENT: { value: 10, text: TimelineLabelType.SENT_DOCUMENT.text, path: TimelineLabelType.SENT_DOCUMENT.path, color: TimelineLabelType.SENT_DOCUMENT.color, backgroundColor: TimelineLabelType.SENT_DOCUMENT.backgroundColor, combination: [TimelineLabelType.SENT_DOCUMENT.value] },
};

export const TimelineStatusLabelType = {
  // タイムラインラベルの種類
  APPROACH: 0, // 注文受付
  APPOINTMENT: 1, //アポ獲得
  CLOSE: 2, //クローズ
  APPROACH_NG: 3, //アプローチNG
  NON_APPROACH: 4, //未アプローチ
  QR_CODE_REACTION: 5, //(QRコード読み込み
  APPROACH_FOLLOWED_UP: 6, //フォロー済み
  APPROACH_NOT_FOLLOWED_UP: 7, //未フォロー
  ARRIVE: 8, //到着
  RESERVE: 9, //注文予約中
  PROOFREAD_CREATED: 10, //校了データ作成済み
  ORDER_SHIPPED: 11, //発送済み
  ORDER_PRINTING: 12, //印刷中
  NON_CONNECT: 13, //未コネクト
  CONNECT: 14, //コネクト
  SENT_DOCUMENT: 15, //資料送付
  DECLINED: 16, //お断り済み
};

export const LetterPlanType = {
  FREE: 0,
  // EXPORT: 1, // 使わない
  LETTER: 2, // フリープラン以外はこの値になる。send_letter_flagとexport_flagでレター送付とエクスポートの権限を判定する
  // ENTERPRISE: 3, // 使わない
};

export const SalesforceObjectType = {
  LEAD: { value: "Lead", text: "リード" },
  // INDIVIDUAL: {value: 'individual', text: '個人'},
  // ACCOUNT: {value: 'account', text: '取引先'},
  CONTACT: { value: "Contact", text: "取引先責任者" },
};

export const SalesforceExeExportObjectType = {
  ACCOUNT: { value: 'Account', text: '取引先' },
  CONTACT: { value: "Contact", text: "取引先責任者" },
  LEAD: { value: "Lead", text: "リード" },
};

export const SalesforceTimelineStatusExportObjectType = {
  EVENT: { value: "Event", text: "活動(Event)" },
}

export const SalesforceImportStep = {
  SELECT_OBJECT: 0,
  SELECT_LISTVIEW: 1,
  MAPPING: 2,
  PREVIEW: 3,
  SETTING_COMPLETE: 4,
  EXPORT_SETTING: 5,

};

export const SalesforceSettingStep = {
  OVERVIEW: -1,
  SELECT_OBJECT: 0,
  SELECT_LISTVIEW: 1,
  MAPPING: 2,
  PREVIEW: 3,
  SETTING_COMPLETE: 4,
  EXPORT_SETTING: 5,
};

export const salesforceAddressSettingSteps = [
  "認証",
  "Salesforceオブジェクトを選択",
  "リストビューを選択",
  "マッピング",
  "確認",
];

export const SalesforceExeSettingStep = {
  OVERVIEW: -1,
  SELECT_OBJECT: 0,
  MAPPING: 1,
  PREVIEW: 2,
  SETTING_COMPLETE: 3,
};

export const salesforceExeSettingSteps = [
  "認証",
  "Salesforceオブジェクトを選択",
  "マッピング",
  "確認"
];

export const salesforceTimelineStatusSettingStep = { // OVERVIEW: -1 は不要なので消した。SalesforceSettingStepとSalesforceExeSettingStepも不要の可能性あり。
  MAPPING: 0,
  PREVIEW: 1,
  SETTING_COMPLETE: 2,
};

export const salesforceTimelineStatusSettingSteps = [
  "認証",
  "マッピング",
  "確認",
];

export const PasswordResetStep = {
  START: { text: "認証", value: -1 },
  VERIFY_EMAIL: { text: "メールアドレスを入力", value: 0 },
  RESET_PASSWORD: { text: "パスワードをリセット", value: 1 },
  SUCCESS: { text: "完了", value: 2 }
};

export const passwordResetSteps = [
  PasswordResetStep.START.text,
  PasswordResetStep.VERIFY_EMAIL.text,
  PasswordResetStep.RESET_PASSWORD.text,
  PasswordResetStep.SUCCESS.text,
]

export const StepStatus = {
  COMPLETED: 0,
  ACTIVE: 1,
  IMCOMPLTE: 2,
};

export const salesforceImportMappingFormProps = [
  { key: "post_code", value: "郵便番号" },
  { key: "address", value: "住所" },
  { key: "company", value: "会社名" },
  { key: "branch", value: "支店・部署" },
  { key: "position", value: "役職" },
  { key: "name", value: "氏名" },
  // { key: "country", value: "国" },
  { key: "honorific", value: "敬称" },
  { key: "tel", value: "電話番号" },
  { key: "fax", value: "FAX番号" },
  {
    key: "email",
    value: "メールアドレス",
  },
  // { key: "tags", value: "リスト" },
  // { key: "timeline_status", value: "ステータス" },
  // { key: "qr_code_reaction", value: "QRコードの読み込み回数" },
  { key: "corporate_number", value: "法人番号" },
];

export const salesforceExeExportMappingFormProps = [
  //{ key: "name", value: "氏名" },
  { key: "last_name", value: "姓" },
  { key: "first_name", value: "名" },
  { key: "position", value: "役職" },
  { key: "company_name", value: "会社名" },
  { key: "post_code", value: "郵便番号" },
  { key: "prefecture_name", value: "住所（都道府県）" },
  { key: "city_name", value: "住所（市町村区）" },
  { key: "street_number", value: "住所（番地）" },
  { key: "tel", value: "電話番号" },
  // { key: "corporate_number", value: "法人番号" },
];

export const salesforceTimelineStatusExportMappingFormProps = [
  { key: "subject", value: "タイトル" },
  { key: "activity_date_time", value: "発送日時・通話日時" },
  { key: "description", value: "説明(発送ステータスや通話結果・通話内容)" },
];

export const perPageOptions = {
  TEN_ITEMS: { value: 10, text: "10件" },
  TWENTY_ITEMS: { value: 20, text: "20件" },
  FIFTY_ITEMS: { value: 50, text: "50件" },
  HUNDRED_ITEMS: { value: 100, text: "100件" },
  TWO_HUNDRED_ITEMS: { value: 200, text: "200件" },
  THOUSAND_ITEMS: { value: 1000, text: "1000件" },
  TWO_THOUSAND_ITEMS: { value: 2000, text: "2000件" },
  FIVE_THOUSAND_ITEMS: { value: 5000, text: "5000件" },
};

export const SalesforceExportMappingFrom= {
  EXE: { value: 1, text: "キーマン" },
  TIMELINE_STATUS: { value: 2, text: "タイムライン" },
};

export const SalesforceExportType = {
  ALL: { value: 0, text: "すべて" },
  EXE: { value: 1, text: "キーマンデータベース" },
  LETTER_ORDER: { value: 2, text: "キャンペーン" },
  REACTION: { value: 3, text: "QRコードリアクション", sobject: "CampaignMember" },
  REVOKE: { value: 4, text: "連携解除" },
  EXE_LETTER_ORDER_CAMPAIGN: { value: 5, text: "キャンペーン(キーマンデータベースからのレター注文)", sobject: "Campaign" },
  HOUSE_LETTER_ORDER_CAMPAIGN: { value: 6, text: "キャンペーン(自社リストからのレター注文)", sobject: "Campaign" },
  EXE_LETTER_ORDER_CAMPAIGN_MEMBER: { value: 7, text: "キャンペーンメンバー(キーマンデータベースからのレター注文)", sobject: "CampaignMember" },
  HOUSE_LETTER_ORDER_CAMPAIGN_MEMBER: { value: 8, text: "キャンペーンメンバー(自社リストからのレター注文)", sobject: "CampaignMember" },
  EXE_FOLLOW_CALL_ORDER_CAMPAIGN: { value: 9, text: "キャンペーン(キーマンデータベースからのフォローコール注文)", sobject: "Campaign" },
  HOUSE_FOLLOW_CALL_ORDER_CAMPAIGN: { value: 10, text: "キャンペーン(自社リストからのフォローコール注文)", sobject: "Campaign" },
  EXE_FOLLOW_CALL_ORDER_CAMPAIGN_MEMBER: { value: 11, text: "キャンペーンメンバー(キーマンデータベースからのフォローコール注文)", sobject: "CampaignMember" },
  HOUSE_FOLLOW_CALL_ORDER_CAMPAIGN_MEMBER: { value: 12, text: "キャンペーンメンバー(自社リストからのフォローコール注文)", sobject: "CampaignMember" },
  LEAD: { value: 13, text: "リード", sobject: "Lead" },
  ACCOUNT: { value: 14, text: "取引先", sobject: "Account" },
  CONTACT: { value: 15, text: "取引先責任者", sobject: "Contact" },
  REVOKE_LEAD: { value: 16, text: "リードの連携解除", sobject: "Lead" },
  REVOKE_ACCOUNT: { value: 17, text: "取引先の連携解除", sobject: "Account" },
  REVOKE_CONTACT: { value: 18, text: "取引先責任者の連携解除", sobject: "Contact" },
  REVOKE_LETTER_ORDER_CAMPAIGN: { value: 19, text: "レター注文のキャンペーンの連携解除", sobject: "Campaign" },
  REVOKE_LETTER_ORDER_CAMPAIGN_MEMBER: { value: 20, text: "レター注文のキャンペーンメンバーの連携解除", sobject: "CampaignMember" },
  REVOKE_FOLLOW_CALL_ORDER_CAMPAIGN: { value: 21, text: "フォローコール注文のキャンペーンの連携解除", sobject: "Campaign" },
  REVOKE_FOLLOW_CALL_ORDER_CAMPAIGN_MEMBER: { value: 22, text: "フォローコール注文のキャンペーンメンバーの連携解除", sobject: "CampaignMember" },
  CALL_HISTORY: { value: 23, text: "コール履歴", sobject: "Event" },
  REVOKE_CALL_HISTORY: { value: 24, text: "コール履歴の連携解除", sobject: "Event" },
  UPDATE_CALL_HISTORY: { value: 25, text: "コール履歴の更新", sobject: "Event" },
  CALL_AUDIO: { value: 26, text: "コール音声", sobject: "ContentDocument" },
  REVOKE_CALL_AUDIO: { value: 27, text: "コール音声の解除", sobject: "ContentDocument" },
  FOLLOW_CALL_APPOINTMENT: { value: 28, text: "アポイント", sobject: "CampaignMember" },
  SHIPPING_STATUS: { value: 29, text: "発送ステータス", sobject: "Event" },
  REVOKE_SHIPPING_STATUS: { value: 30, text: "発送ステータスの連携解除", sobject: "Event" },
  UPDATE_SHIPPING_STATUS: { value: 31, text: "発送ステータスの更新", sobject: "Event" },
  EXE_LETTER_ORDER_CAMPAIGN_MEMBER_FOR_LEAD_CONVERTED_CONTACT: { value: 32, text: "キャンペーンメンバー(キーマンデータベースからのレター注文でリードから昇格した取引先責任者)", sobject: "CampaignMember" },
  HOUSE_LETTER_ORDER_CAMPAIGN_MEMBER_FOR_LEAD_CONVERTED_CONTACT: { value: 33, text: "キャンペーンメンバー(自社リストからのレター注文でリード昇格した取引先責任者)", sobject: "CampaignMember" },
  EXE_FOLLOW_CALL_ORDER_CAMPAIGN_MEMBER_FOR_LEAD_CONVERTED_CONTACT: { value: 34, text: "キャンペーンメンバー(キーマンデータベースからのフォローコール注文でリードから昇格した取引先責任者)", sobject: "CampaignMember" },
  HOUSE_FOLLOW_CALL_ORDER_CAMPAIGN_MEMBER_FOR_LEAD_CONVERTED_CONTACT: { value: 35, text: "キャンペーンメンバー(自社リストからのフォローコール注文でリードから昇格した取引先責任者)", sobject: "CampaignMember" },
  REVOKE_LEAD_CONVERTED_CONTACT: { value: 36, text: "リードから昇格した取引先責任者の連携解除", sobject: "Contact" },
}

export const SalesforceJobState = {
  UPLOADING: { value: 0, text: "処理中" },
  SUCCESS: { value: 1, text: "完了" },
  FAILED: { value: 2, text: "失敗" },
  PARTIAL_SUCCESS: { value: 3, text: "完了（一部成功）" },
}

export const ChildAccountLetterOrderAuthorityValue = {
  // UNACCESSIBLE: { value: 0, text: "アクセス不可" }, //最低限、閲覧にしないとダッシュボードなど影響が出るため一旦OFF
  READ: { value: 1, text: "閲覧" },
}

export const ChildAccountDownloadHistoryAuthorityValue = {
  UNACCESSIBLE: { value: 0, text: "アクセス不可" },
  READ: { value: 1, text: "閲覧" },
}

export const ChildAccountTimelineAuthorityValue = {
  // UNACCESSIBLE: { value: 0, text: "アクセス不可" }, //最低限、閲覧にしないとダッシュボードなど影響が出るため一旦OFF
  READ: { value: 1, text: "閲覧" },
  EDIT: { value: 2, text: "ステータスの編集" },
}

export const ChildAccountAuthorityValue = {
  UNACCESSIBLE: { value: 0, text: "アクセス不可" },
  READ: { value: 1, text: "閲覧" },
  EDIT: { value: 2, text: "編集" },
}

export const PromotePlanDialogTypes = {
  LETTER_CORRECTION: { flag: "showPromoteLetterCollectionDialog", title: "レター文面の添削" },
  LETTER_AUTO_GENERATE: { flag: "showPromoteLetterAutoGenerateDialog", title: "レター文面の自動生成" },
  REACTION_KEYWORD: { flag: "showPromoteReactionKeywordDialog", title: "関心のあるキーワード", desc: "関心のあるキーワードを表示することができます。この機能をご利用いただくには、オプションの変更が必要です。右下のチャットフォームまたは、下記いずれかの連絡先より、貴社名をご連絡ください。ご質問のみでもけっこうでございます。ご連絡お待ちしております。" },
  DEPARTMENT_TEL: { flag: "showPromoteDepartmentTelDialog", title: "部門電話番号の表示", desc: "この機能をご利用いただくには、オプションの変更が必要です。右下のチャットフォームまたは、下記いずれかの連絡先より、貴社名をご連絡ください。ご質問のみでもけっこうでございます。ご連絡お待ちしております。" },
  SALESFORCE_TIMELINE_STATUS: { flag: "showPromoteSalesforceTimelineStatusDialog", title: "タイムラインのSalesforce連携", desc: "この機能をご利用いただくには、オプションの変更が必要です。右下のチャットフォームまたは、下記いずれかの連絡先より、貴社名をご連絡ください。ご質問のみでもけっこうでございます。ご連絡お待ちしております。" },
};

const dayCountAtWeek = 7;
const dayCountAt2Week = 14;
const dayCountAtMonth = 30;

export const DateRanges = {
  UNSPECIFIED: { value: 0, text: '期間指定なし', from: null, to: moment() },
  TODAY: { value: 1, text: '今日', from: moment(), to: moment() },
  // YESTERDAY: {value: 2, text: '昨日', from: moment().subtract(1, 'day'), to: moment().subtract(1, 'day')}, 一旦OFF
  PAST_7_DAYS: { value: 3, text: '過去7日間', from: moment().subtract(dayCountAtWeek, 'day'), to: moment() },
  PAST_14_DAYS: { value: 4, text: '過去14日間', from: moment().subtract(dayCountAt2Week, 'day'), to: moment() },
  PAST_30_DAYS: { value: 5, text: '過去30日間', from: moment().subtract(dayCountAtMonth, 'day'), to: moment() },
  PAST_1_YEAR: { value: 6, text: '過去1年間', from: moment().subtract(1, 'year'), to: moment() },
  // USER_SPECIFIED: {value: 7, text: '期間指定', from: moment().subtract(1, 'day'), to: moment()}, // TODO: あとで実装
}

export const DateRangesV2 = {
  UNSPECIFIED: { value: 0, text: '期間指定なし', from: null, to: moment() },
  TODAY: { value: 1, text: '今日', from: moment(), to: moment() },
  YESTERDAY: { value: 2, text: '昨日', from: moment().subtract(1, 'day'), to: moment().subtract(1, 'day') },
  PAST_7_DAYS: { value: 3, text: '過去7日間', from: moment().subtract(dayCountAtWeek, 'day'), to: moment() },
  PAST_14_DAYS: { value: 4, text: '過去14日間', from: moment().subtract(dayCountAt2Week, 'day'), to: moment() },
  PAST_30_DAYS: { value: 5, text: '過去30日間', from: moment().subtract(dayCountAtMonth, 'day'), to: moment() },
  PAST_1_YEAR: { value: 6, text: '過去1年間', from: moment().subtract(1, 'year'), to: moment() },
  USER_SPECIFIED: { value: 7, text: '期間指定', from: moment().subtract(1, 'day'), to: moment() }, // TODO: あとで実装
}




// WEBPACK FOOTER //
// ./src/constants/ComponentTypes.js